export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              移动端入口
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-4">
              随时随地看爆料
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">
              51爆料网支持移动端浏览器直接访问，无需下载安装。打开手机浏览器输入网址即可浏览最新爆料内容，
              界面自适应手机屏幕，操作流畅便捷。无论您身处何地，都能第一时间获取最新最热的爆料资讯。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 border border-background-200">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700">手机浏览器直达</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 border border-background-200">
                <i className="ri-qr-code-line text-accent-600 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700">扫码快速访问</span>
              </div>
            </div>
          </div>
          <div className="w-40 h-40 md:w-48 md:h-48 shrink-0 rounded-2xl bg-background-50 border-2 border-background-300 flex items-center justify-center">
            <i className="ri-smartphone-line text-5xl text-foreground-300"></i>
          </div>
        </div>
      </div>
    </section>
  );
}